const ready = () => {

	require('./layout/card')();
	require('./layout/sidebar')();

};

const complete = () => {

	require('./layout/site-header')();
	require('./layout/odds-grid')();
	require('./layout/race-header')();

};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', ready);
}

var completeInterval = setInterval(function() {
	if(document.readyState === 'complete') {
		clearInterval(completeInterval);
		complete();
	}
}, 100);



// WEBPACK FOOTER //
// ./src/js/site--desktop.js